import React from 'react'
import { LoaderDiv } from './LoadingStyled'
interface LOADER_PROPS {
  colors: any
  handleReturnToPage: any
}
export default function Loader({ colors, handleReturnToPage }: LOADER_PROPS) {
  return (
    <LoaderDiv colors={colors} onAnimationEnd={() => handleReturnToPage()}>
      <p>
        Loading
        <span />
        <span />
        <span />
      </p>
    </LoaderDiv>
  )
}
